import { Card } from "@/components/ui/card";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { getTransactionTypeLabel } from "@/components/history/TransactionTypeUtils";
import { MediaPreviewDialog } from "@/components/history/MediaPreviewDialog";
import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Eye } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ReturnCardProps {
  transaction: any;
}

export const ReturnCard = ({ transaction }: ReturnCardProps) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const isLoss = transaction.transaction_type === "loss";

  // Extract proof URL from notes if it exists
  const extractProofUrl = (notes: string) => {
    if (!notes) return null;
    const match = notes.match(/\[proof_url:(.*?)\]/);
    return match ? match[1] : null;
  };

  // Clean notes by removing the proof URL part
  const cleanNotes = (notes: string) => {
    if (!notes) return "";
    return notes.replace(/\s*\[proof_url:.*?\]/, "").trim();
  };

  const proofUrl = isLoss ? extractProofUrl(transaction.notes) : null;
  const reason = isLoss ? cleanNotes(transaction.notes) : null;

  return (
    <Card className="p-4">
      <div className="space-y-2">
        <div className="font-medium">
          {transaction.stock_items?.data?.name || "Produit non spécifié"}
        </div>
        <div className="text-sm text-gray-500">
          Type: {getTransactionTypeLabel(transaction.transaction_type)}
        </div>
        <div className="text-sm text-gray-500">
          Quantité: {transaction.quantity}
        </div>
        <div className="text-sm text-gray-500">
          Date: {format(new Date(transaction.created_at), "PPP", { locale: fr })}
        </div>
        {isLoss && reason && (
          <div className="text-sm text-gray-500">
            Raison: {reason}
          </div>
        )}
        {transaction.return_condition && (
          <div className="text-sm text-gray-500">
            État: {transaction.return_condition}
          </div>
        )}
        {transaction.refund_amount > 0 && (
          <div className="text-sm font-medium text-red-600">
            Remboursement: -{transaction.refund_amount.toLocaleString()} FCFA
          </div>
        )}
        {isLoss && proofUrl && (
          <div className="mt-2">
            <Button 
              variant="outline" 
              size="sm"
              className="flex items-center gap-2 text-blue-600 hover:text-blue-700"
              onClick={() => setIsPreviewOpen(true)}
            >
              <Eye className="h-4 w-4" />
              Voir la preuve
            </Button>
            <MediaPreviewDialog
              open={isPreviewOpen}
              onOpenChange={setIsPreviewOpen}
              url={proofUrl}
            />
          </div>
        )}
      </div>
    </Card>
  );
};